import { all, fork } from 'redux-saga/effects';

import {
  sessionSetup,
  sessionTokenInit,
  sessionWishlist
} from '../modules/session/actions';
import {
  changeLocalePending,
  setupLocalStorageLocaleChange
} from '../modules/locale/actions';
import {
  onUpdateCreditCard
} from '../modules/stripe/actions/watchers';
import {
  onDashboardMountWatcher,
  dashboardDownloadReportInit,
  redirectToHomepageOnMountError,
  fetchAccountReportOnTimeFilterChange,
  onSelectCustomEventsComplete,
  fetchAccountReportOnSelectedEventChange
} from '../modules/dashboard/actions/watchers';
import {
  fetchListingPending,
  flagListingWatcher,
  updateEventWatcher,
  wishlistListingWatcher,
  unWishlistListingWatcher
} from '../modules/listing/actions';
import {
  onMyTicketsInit,
  onMyPassesInit,
  onMyTicketsCurrentSuccess,
  onRequestMoreTicketsSuccess,
  onMyTicketsPastSuccess,
  redirectToSignInOnError,
  redirectToSignInOnPassesError,
  onRequestRefund,
  onRequestCancel,
  onRequestTransferTicket,
  onRequestCancelTicketTransfer,
  onRequestResendTicketTransfer,
  onRequestUpdateCostItemHostFields,
  onRequestUpdateTicketHostFields,
  onAddFlashMessage,
  onPagination,
  onTogglePassOpen
} from '../modules/my-tickets/actions/watchers';
import {
  onPaymentPlanInit,
  onPaymentInstallment,
  onPayAllInstallment,
  redirectToHomepageOnPaymentPlansMountError
} from '../modules/payment-plans/actions/watchers';
import {
  onYourOrderInit,
  onYourOrderRequestCancel,
  redirectToHomepageOnYourOrderMountError
} from '../modules/your-order/actions/watchers';
import {
  onYourTicketInit,
  redirectToHomepageOnYourTicketMountError
} from '../modules/your-ticket/actions/watchers';
import {
  onRequestGenerateInvoice
} from '../modules/invoice/actions/watchers';

import {
  onBetaDashboardMount,
  redirectToHomepageOnBetaMountError,
  fetchAccountReportOnTimeFilterChangeBeta
} from '../modules/beta-dashboard/actions/watchers';

import {
  onReportsMountWatcher,
  redirectToSignInOnReportsMountError,
  reportsDownloadReportInit,
  onDownloadReport,
  onSaveReport,
  onReportsSelectCustomEventsComplete,
  onDeleteReport,
} from '../modules/reports/actions/watchers';

import {
  onGDCMountWatcher,
  redirectToHomepageOnGDCMountError,
  GDCReportDownloadInit
} from '../modules/codes/actions/watchers';

import {
  onMyEventsMountWatcher,
  redirectToHomepageOnEventsMountError
} from '../modules/my-events/actions/watchers';

function* rootSaga() {
  yield all([
    // SESSION
    fork(sessionSetup), // <-- ready to fetch a session
    fork(sessionTokenInit), // <-- has to come after sessionSetup, initilizes session fetching
    fork(sessionWishlist),

    // LOCALE
    fork(changeLocalePending),
    fork(setupLocalStorageLocaleChange),

    // DASHBOARD
    fork(onDashboardMountWatcher),
    fork(dashboardDownloadReportInit),
    fork(redirectToHomepageOnMountError),
    fork(fetchAccountReportOnTimeFilterChange),
    fork(onSelectCustomEventsComplete),
    fork(fetchAccountReportOnSelectedEventChange),

    // EDP
    fork(fetchListingPending),
    fork(flagListingWatcher),
    fork(updateEventWatcher),
    fork(wishlistListingWatcher),
    fork(unWishlistListingWatcher),

    // MY TICKETS & PASSES
    fork(onMyTicketsInit),
    fork(onMyPassesInit),
    fork(onMyTicketsCurrentSuccess),
    fork(onRequestMoreTicketsSuccess),
    fork(onMyTicketsPastSuccess),
    fork(onRequestRefund),
    fork(onRequestCancel),
    fork(onRequestTransferTicket),
    fork(onRequestCancelTicketTransfer),
    fork(onRequestResendTicketTransfer),
    fork(onRequestUpdateCostItemHostFields),
    fork(onRequestUpdateTicketHostFields),
    fork(onAddFlashMessage),
    fork(onPagination),
    fork(onUpdateCreditCard),
    fork(redirectToSignInOnError),
    fork(redirectToSignInOnPassesError),
    fork(onTogglePassOpen),

    // PAYMENT PLANS
    fork(onPaymentPlanInit),
    fork(onPaymentInstallment),
    fork(onPayAllInstallment),
    fork(redirectToHomepageOnPaymentPlansMountError),

    // YOUR ORDERS
    fork(onYourOrderInit),
    fork(onYourOrderRequestCancel),
    fork(redirectToHomepageOnYourOrderMountError),
    fork(onYourTicketInit),
    fork(redirectToHomepageOnYourTicketMountError),

    // YOUR TICKET
    fork(onYourTicketInit),
    fork(redirectToHomepageOnYourTicketMountError),

    // INVOICE
    fork(onRequestGenerateInvoice),

    // BETA DASHBOARD
    fork(onBetaDashboardMount),
    fork(redirectToHomepageOnBetaMountError),
    fork(fetchAccountReportOnTimeFilterChangeBeta),

    // BETA REPORTS
    fork(onReportsMountWatcher),
    fork(redirectToSignInOnReportsMountError),
    fork(reportsDownloadReportInit),
    fork(onReportsSelectCustomEventsComplete),
    fork(onDownloadReport),
    fork(onSaveReport),
    fork(onDeleteReport),

    // Global Discount Codes
    fork(onGDCMountWatcher),
    fork(redirectToHomepageOnGDCMountError),
    fork(GDCReportDownloadInit),

    // MY EVENTS
    fork(onMyEventsMountWatcher),
    fork(redirectToHomepageOnEventsMountError)
  ]);
}

export default rootSaga;



// WEBPACK FOOTER //
// ./src/store/sagas.js